import {useContext as $8qd2c$useContext} from "react";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;


var $4bJ9d = parcelRequire("4bJ9d");
var $14333e5544568b57$exports = {};

$14333e5544568b57$exports = (parcelRequire("daZiC")).getBundleURL('8qd2c') + "note.88f0297b.js";


var $c5a8b5ef2a5d59fb$exports = {};

$c5a8b5ef2a5d59fb$exports = (parcelRequire("daZiC")).getBundleURL('8qd2c') + "defs.c12a28fc.js";



var $aVUB5 = parcelRequire("aVUB5");

var $dl5CL = parcelRequire("dl5CL");

var $jMtLz = parcelRequire("jMtLz");
var $bebbe38bbdd4f63b$exports = {};

$bebbe38bbdd4f63b$exports = (parcelRequire("daZiC")).getBundleURL('8qd2c') + "new.7ef27eca.js";


var $dabb03762486ca1a$exports = {};

$dabb03762486ca1a$exports = (parcelRequire("daZiC")).getBundleURL('8qd2c') + "types.5862815c.js";


function $c847b9cc9be90f1e$export$1e92413934596f41(props) {
    const { visibility: visibility, note: note, onClick: onClick } = props;
    const text = note.note;
    return (0, $4bJ9d.default)("p.col-note-label", {
        style: {
            visibility: visibility
        },
        onClick: onClick
    }, text);
}
const $c847b9cc9be90f1e$var$CancelEditUnderlay = function() {
    const { setEditingNote: setEditingNote } = (0, $8qd2c$useContext)((0, $jMtLz.NoteEditorContext));
    const { confirmChanges: confirmChanges } = (0, $aVUB5.useModelEditor)();
    return (0, $4bJ9d.default)((0, $dl5CL.NoteUnderlay), {
        onClick () {
            console.log("Clicked to cancel note editing");
            return setEditingNote(null);
        }
    });
};
function $c847b9cc9be90f1e$var$EditableNotesColumn(props) {
    const { width: width, paddingLeft: paddingLeft = 60, transform: transform, notes: notes, inEditMode: inEditMode = false, onUpdateNote: onUpdateNote, onDeleteNote: onDeleteNote, onCreateNote: onCreateNote, noteComponent: noteComponent = $c847b9cc9be90f1e$export$1e92413934596f41, noteEditor: noteEditor = (0, $jMtLz.NoteTextEditor), allowPositionEditing: allowPositionEditing = false, forceOptions: forceOptions } = props;
    const innerWidth = width - paddingLeft;
    return (0, $4bJ9d.default)((0, $dl5CL.NoteLayoutProvider), {
        notes: notes,
        width: innerWidth,
        paddingLeft: paddingLeft,
        noteComponent: noteComponent,
        forceOptions: forceOptions
    }, [
        (0, $4bJ9d.default)((0, $jMtLz.NoteEditorProvider), {
            inEditMode: inEditMode,
            noteEditor: noteEditor,
            onCreateNote: onCreateNote,
            onUpdateNote: onUpdateNote,
            onDeleteNote: onDeleteNote
        }, [
            (0, $4bJ9d.default)("g.section-log", {
                transform: transform
            }, [
                (0, $4bJ9d.default)((0, (/*@__PURE__*/$parcel$interopDefault($c5a8b5ef2a5d59fb$exports)))),
                (0, $4bJ9d.default)($c847b9cc9be90f1e$var$CancelEditUnderlay),
                (0, $4bJ9d.default)((0, $14333e5544568b57$exports.NotesList), {
                    editHandler: inEditMode ? onUpdateNote : null,
                    inEditMode: inEditMode
                }),
                (0, $4bJ9d.default)((0, $bebbe38bbdd4f63b$exports.NewNotePositioner)),
                (0, $4bJ9d.default)((0, $jMtLz.NoteEditor), {
                    allowPositionEditing: allowPositionEditing
                })
            ])
        ])
    ]);
}
function $c847b9cc9be90f1e$export$c6e73cac972b98c9(props) {
    const { width: width, paddingLeft: paddingLeft = 60, transform: transform, notes: notes, noteComponent: noteComponent = $c847b9cc9be90f1e$export$1e92413934596f41 } = props;
    const innerWidth = width - paddingLeft;
    return (0, $4bJ9d.default)((0, $dl5CL.NoteLayoutProvider), {
        notes: notes,
        width: innerWidth,
        paddingLeft: paddingLeft,
        noteComponent: noteComponent
    }, [
        (0, $4bJ9d.default)("g.section-log", {
            transform: transform
        }, [
            (0, $4bJ9d.default)((0, (/*@__PURE__*/$parcel$interopDefault($c5a8b5ef2a5d59fb$exports)))),
            (0, $4bJ9d.default)((0, $14333e5544568b57$exports.NotesList), {
                inEditMode: false
            })
        ])
    ]);
}
function $c847b9cc9be90f1e$export$78231d3424a637d3(props) {
    const { editable: editable = true, ...rest } = props;
    const ctx = (0, $8qd2c$useContext)((0, $aVUB5.ColumnContext));
    // not sure why we have this here.
    if (ctx?.scaleClamped == null) return null;
    const c = editable ? $c847b9cc9be90f1e$var$EditableNotesColumn : $c847b9cc9be90f1e$export$c6e73cac972b98c9;
    return (0, $4bJ9d.default)(c, rest);
}


//# sourceMappingURL=notes.237bcaa6.js.map
